var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNxiTherapeuticsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3425.1 748.3",
    style: {
      enableBackground: "new 0 0 3425.1 748.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0F256E;}\r\n\t.st1{fill:#204ECF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M612.3,663.2h-57.5l-116-202H438v202h-51.4V385.3h58.6l114.9,202h0.8v-202h51.4V663.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M892.1,663.2h-59.3L766,567.1l-65,96.1h-61.2l95.8-138.6l-95.8-139.3H701l65,96.9l66.8-96.9h59.3L796,524.6 L892.1,663.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M972.1,663.2h-51.4V385.3h51.4V663.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1260.8,433.4H1209v229.8h-51.4V433.4h-51.4v-48.1h154.7L1260.8,433.4L1260.8,433.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1466.6,663.2h-49.9V556.6c0-8.8-0.5-16.4-1.5-22.9s-2.9-13.1-5.6-19.7c-2.8-6.6-7.1-11.7-13.1-15.2 s-13.5-5.3-22.5-5.3c-8.8,0-16.1,1.9-22.2,5.6c-6,3.8-10.3,9-13,15.8c-2.6,6.8-4.4,13.4-5.4,19.9s-1.5,14-1.5,22.5v105.9H1282 V385.3h49.9v84.1c15.3-14.5,33.3-21.8,54.1-21.8c11.8,0,23.6,2.9,35.5,8.8s21.5,13.6,28.7,23.1c11,14.3,16.5,35.2,16.5,62.7 L1466.6,663.2L1466.6,663.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1716,556.2c0,8-1,16.4-3,25.2h-161.8c1,4.8,3.3,9.8,6.8,15c12,18.5,28.9,27.8,50.7,27.8 c22.3,0,38.3-8.9,48.1-26.7h52.6c-6.8,21-19.7,38.4-38.7,52s-39.7,20.5-62,20.5c-31,0-57.1-10.6-78.3-31.9 c-21.2-21.3-31.7-47.4-31.7-78.5c0-31.3,10.4-57.8,31.4-79.4c20.9-21.7,47-32.5,78.3-32.5c30.3,0,55.8,10.5,76.6,31.5 C1705.6,500.2,1716,525.9,1716,556.2z M1664.9,541.1c-2.5-15-8.7-26.7-18.6-35.1s-22.5-12.6-37.7-12.6c-15,0-27.7,4.2-38.1,12.6 s-17.3,20.1-20.8,35.1H1664.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1846.3,496.1c-30.3,1-45.4,17.6-45.4,49.9v117.2H1751V454.8h45.8v18.4h0.8c7-10,13.8-16.8,20.3-20.3 s16-5.3,28.5-5.3v48.5H1846.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2067.4,663.2h-45.8v-25.9c-8.3,9.8-19.2,17.6-32.9,23.7c-13.6,6-27,9-40,9c-30.3,0-54.8-11-73.4-33 c-18.7-22-28-48.4-28-79.2c0-30.5,9.8-56.5,29.5-77.9s44.6-32.1,74.9-32.1c23,0,43.6,8.3,61.6,24.8c3.8,3.8,6.3,6.6,7.5,8.6h0.8 v-26.3h45.8L2067.4,663.2L2067.4,663.2z M2003.2,605c11.3-12.8,16.9-28.3,16.9-46.6c0-18.3-5.6-33.7-16.9-46.2 c-11.3-12.5-25.9-18.8-43.9-18.8s-32.9,6.5-44.5,19.5s-17.5,28.7-17.5,46.9c0,17.8,5.9,32.9,17.8,45.4 c11.9,12.5,26.6,18.8,44.1,18.8C1977.3,624.1,1992,617.7,2003.2,605z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2291.6,480.1c19.8,21.7,29.7,47.6,29.7,77.9s-10,56.5-29.9,78.7s-44.8,33.2-74.5,33.2 c-13.5,0-25.1-2.1-34.7-6.2c-9.6-4.1-19.5-10.9-29.5-20.5v89.4h-49.9V454.7h45.8v24.4h0.8c16.8-21,39.3-31.5,67.6-31.5 C2246.9,447.6,2271.8,458.5,2291.6,480.1z M2253.9,604.4c11.6-13.1,17.5-28.4,17.5-45.6s-5.8-32.5-17.3-45.6s-25.8-19.7-42.8-19.7 c-17.8,0-32.5,6.4-44.1,19.3s-17.5,28.2-17.5,46c0,13.3,3.1,25.2,9.4,35.7c6.3,10.5,15.3,18.4,27,23.7c8,4,16.1,6,24.4,6 C2227.8,624.1,2242.2,617.6,2253.9,604.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2562,556.2c0,8-1,16.4-3,25.2h-161.8c1,4.8,3.3,9.8,6.8,15c12,18.5,28.9,27.8,50.7,27.8 c22.3,0,38.3-8.9,48.1-26.7h52.6c-6.8,21-19.7,38.4-38.7,52s-39.7,20.5-62,20.5c-31,0-57.1-10.6-78.3-31.9s-31.7-47.4-31.7-78.5 c0-31.3,10.5-57.8,31.4-79.4c20.9-21.7,47-32.5,78.3-32.5c30.3,0,55.8,10.5,76.6,31.5C2551.6,500.2,2562,525.9,2562,556.2z  M2510.9,541.1c-2.5-15-8.7-26.7-18.6-35.1c-9.9-8.4-22.5-12.6-37.7-12.6c-15,0-27.7,4.2-38.1,12.6c-10.4,8.4-17.3,20.1-20.8,35.1 H2510.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2777.5,663.2h-45.8v-21h-0.8c-13.5,18.5-31.4,27.8-53.7,27.8c-14,0-27.3-2.8-39.8-8.4s-22.5-13.8-30-24.6 c-10.3-14.8-15.4-38.7-15.4-71.7V454.9h49.9v106.3c0,42.1,14.5,63.1,43.6,63.1c8.3,0,15.3-1.9,21-5.6c5.8-3.8,10.1-8.9,13-15.4 s4.9-13.1,6.2-19.9s1.9-14,1.9-21.8V455h49.9L2777.5,663.2L2777.5,663.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2910.8,499.1h-30v164.1h-49.9V499.1h-24.5v-44.3h24.4v-69.5h49.9v69.5h30v44.3H2910.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2981,431.1h-49.9v-45.8h49.9V431.1z M2981,663.2h-49.9V454.8h49.9V663.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3230.4,595.2c-8.3,23-21.7,41.2-40.2,54.6s-39.9,20.1-64.2,20.1c-30.8,0-57-10.9-78.5-32.9 c-21.5-21.9-32.3-48.3-32.3-79c0-30.5,10.8-56.6,32.5-78.1s47.6-32.3,77.9-32.3c24.3,0,45.9,6.9,64.8,20.7 c18.9,13.8,32.2,32.3,40,55.6h-56.3c-11.3-20.3-27.4-30.4-48.4-30.4c-18,0-32.6,6.3-43.7,19c-11.1,12.6-16.7,28.1-16.7,46.4 s5.9,33.7,17.6,46.4c11.8,12.6,26.8,19,45.1,19c18.8,0,34.2-9.6,46.2-28.9h56.2V595.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3399.7,597.1c0,20.5-6.9,37.8-20.8,51.8c-13.9,14-31.2,21-52,21c-12,0-23.7-2.3-34.9-6.9 c-11.3-4.6-20.4-11.5-27.4-20.5c-9-11.3-14.3-26.3-15.8-45.1h51.1c4,17.8,13.1,26.7,27.4,26.7c6.3,0,11.6-1.9,16-5.8 s6.6-8.9,6.6-15.2c0-4.3-1-7.9-3-10.9c-1.5-2.3-4.4-4.5-8.6-6.8c-4.3-2.3-8.1-4-11.5-5.3s-8-2.9-13.9-4.9s-9.2-3.1-10-3.4 c-31-11-46.6-30.9-46.6-59.7c0-18.5,6.9-33.9,20.8-46.2c13.9-12.3,30.2-18.4,49-18.4c18.3,0,34,6.1,47.1,18.4s20.1,27.4,20.8,45.4 h-48.8c-2.5-12-9.1-18-19.9-18c-5.3,0-9.8,1.7-13.5,5.1c-3.8,3.4-5.6,7.7-5.6,13c0,3.5,1,6.4,3,8.8s3.9,4,5.6,4.9 c1.7,0.9,4.6,2.1,8.6,3.6s10,3.5,18,6c19,6,33.5,13.5,43.4,22.3C3394.8,566,3399.7,579.3,3399.7,597.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.285875e-02 -0.9973 0.9973 7.285875e-02 319.8375 452.9567)",
    className: "st1",
    cx: 403.5,
    cy: 54.5,
    rx: 38.2,
    ry: 57.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.380170e-02 -0.9973 0.9973 7.380170e-02 304.9109 585.45)",
    className: "st1",
    cx: 467.6,
    cy: 128.6,
    rx: 34.5,
    ry: 51.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.055746e-02 -0.9975 0.9975 7.055746e-02 293.68 708.7649)",
    className: "st1",
    cx: 527.2,
    cy: 196.8,
    rx: 32.3,
    ry: 49.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.250393e-02 -0.9974 0.9974 7.250393e-02 281.152 829.9026)",
    className: "st1",
    cx: 586.8,
    cy: 263.8,
    rx: 27.9,
    ry: 42.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.388535e-02 -0.9973 0.9973 7.388535e-02 172.1412 769.9283)",
    className: "st1",
    cx: 500.6,
    cy: 292.3,
    rx: 25.9,
    ry: 38.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1021 -0.9948 0.9948 0.1021 156.7686 650.5229)",
    className: "st1",
    cx: 438.7,
    cy: 238.4,
    rx: 28.8,
    ry: 38.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.233267e-02 -0.9974 0.9974 7.233267e-02 158.2669 529.0032)",
    className: "st1",
    cx: 363.5,
    cy: 179.4,
    rx: 28.9,
    ry: 43.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.328863e-02 -0.9973 0.9973 7.328863e-02 151.7851 406.4799)",
    className: "st1",
    cx: 294.6,
    cy: 121.6,
    rx: 32.8,
    ry: 49.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.125626e-02 -0.9975 0.9975 7.125626e-02 3.4604 376.3667)",
    className: "st1",
    cx: 203.8,
    cy: 186.3,
    rx: 29.4,
    ry: 44.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.790990e-02 -0.9977 0.9977 6.790990e-02 31.0876 499.5988)",
    className: "st1",
    cx: 282.9,
    cy: 233.2,
    rx: 29.4,
    ry: 45.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(8.558570e-02 -0.9963 0.9963 8.558570e-02 50.9787 618.6399)",
    className: "st1",
    cx: 362.5,
    cy: 281.5,
    rx: 26.8,
    ry: 38.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.362230e-02 -0.998 0.998 6.362230e-02 83.7407 731.9467)",
    className: "st1",
    cx: 431.9,
    cy: 321.3,
    rx: 22.4,
    ry: 35.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.362230e-02 -0.998 0.998 6.362230e-02 -2.9967 699.2889)",
    className: "st1",
    cx: 371.1,
    cy: 351.2,
    rx: 22.4,
    ry: 35.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9998 -1.759435e-02 1.759435e-02 0.9998 -5.6132 5.3088)",
    className: "st1",
    cx: 298.9,
    cy: 321.7,
    rx: 33.4,
    ry: 22.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.668731e-02 1.668731e-02 0.9999 -4.7152 3.6365)",
    className: "st1",
    cx: 215.5,
    cy: 284.4,
    rx: 34.4,
    ry: 23.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9999 -1.644142e-02 1.644142e-02 0.9999 -4.1274 2.2708)",
    className: "st1",
    cx: 136,
    cy: 252.2,
    rx: 38.2,
    ry: 25.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9997 -2.240134e-02 2.240134e-02 0.9997 -6.932 2.1056)",
    className: "st1",
    cx: 90.5,
    cy: 310.5,
    rx: 35.5,
    ry: 23.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 167.9,
    cy: 335.7,
    rx: 30.7,
    ry: 22.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9997 -2.405096e-02 2.405096e-02 0.9997 -8.6468 6.0652)",
    className: "st1",
    cx: 247.8,
    cy: 362.5,
    rx: 29.8,
    ry: 19.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -2.463171e-03 2.463171e-03 1 -0.9474 0.7833)",
    className: "st1",
    cx: 317.5,
    cy: 385,
    rx: 28.1,
    ry: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -6.848120e-03 6.848120e-03 1 -2.8426 1.9063)",
    className: "st1",
    cx: 276.9,
    cy: 416,
    rx: 25.4,
    ry: 17.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9919 -0.1272 0.1272 0.9919 -49.1976 29.8987)",
    className: "st1",
    cx: 209.5,
    cy: 400.2,
    rx: 25.4,
    ry: 17.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9971 -7.553498e-02 7.553498e-02 0.9971 -28.6947 11.4417)",
    className: "st1",
    cx: 136.9,
    cy: 385.1,
    rx: 22.6,
    ry: 17.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9961 -8.856139e-02 8.856139e-02 0.9961 -32.1816 6.5685)",
    className: "st1",
    cx: 57.9,
    cy: 366,
    rx: 23.1,
    ry: 17.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9997 -2.441178e-02 2.441178e-02 0.9997 -10.0467 1.2464)",
    className: "st1",
    cx: 46,
    cy: 412.1,
    rx: 21.1,
    ry: 17.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9959 -9.093624e-02 9.093624e-02 0.9959 -38.2784 13.0113)",
    className: "st1",
    cx: 123.6,
    cy: 426.6,
    rx: 22.1,
    ry: 16.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9962 -8.655173e-02 8.655173e-02 0.9962 -37.2839 17.7894)",
    className: "st1",
    cx: 186.5,
    cy: 438.9,
    rx: 20.6,
    ry: 15.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9934 -0.1147 0.1147 0.9934 -49.9283 31.3648)",
    className: "st1",
    cx: 247.6,
    cy: 449.5,
    rx: 20.6,
    ry: 14.5
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1889 -0.982 0.982 0.1889 -399.2206 425.79)",
    className: "st1",
    cx: 58.1,
    cy: 454.6,
    rx: 14,
    ry: 16.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1432 -0.9897 0.9897 0.1432 -354.3318 520.0625)",
    className: "st1",
    cx: 123.2,
    cy: 464.7,
    rx: 14,
    ry: 17.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1432 -0.9897 0.9897 0.1432 -310.0489 587.9259)",
    className: "st1",
    cx: 184.5,
    cy: 473,
    rx: 14,
    ry: 17.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.617832e-02 -0.9954 0.9954 9.617832e-02 -263.4124 672.3257)",
    className: "st1",
    cx: 238.5,
    cy: 481.2,
    rx: 12.7,
    ry: 17.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.521463e-02 -0.9955 0.9955 9.521463e-02 -286.9036 702.2843)",
    className: "st1",
    cx: 242.9,
    cy: 509,
    rx: 10.3,
    ry: 14.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.312606e-02 -0.9973 0.9973 7.312606e-02 -320.9272 663.8973)",
    className: "st1",
    cx: 196.7,
    cy: 504.6,
    rx: 10.4,
    ry: 15.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.984378e-02 -0.9968 0.9968 7.984378e-02 -368.099 597.106)",
    className: "st1",
    cx: 139.4,
    cy: 497.9,
    rx: 11.2,
    ry: 16.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.984378e-02 -0.9968 0.9968 7.984378e-02 -412.7921 534.0647)",
    className: "st1",
    cx: 82.9,
    cy: 490.6,
    rx: 11.2,
    ry: 16.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1985 -0.9801 0.9801 0.1985 -421.1336 521.516)",
    className: "st1",
    cx: 108.3,
    cy: 518.2,
    rx: 11.1,
    ry: 13.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1086 -0.9941 0.9941 0.1086 -376.7622 627.8907)",
    className: "st1",
    cx: 161.7,
    cy: 524,
    rx: 9.8,
    ry: 13
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.129005e-02 -0.9975 0.9975 7.129005e-02 -334.7605 702.6417)",
    className: "st1",
    cx: 209.9,
    cy: 531.1,
    rx: 8.9,
    ry: 13.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(7.129005e-02 -0.9975 0.9975 7.129005e-02 -294.4652 753.6972)",
    className: "st1",
    cx: 257.5,
    cy: 535,
    rx: 8.9,
    ry: 13.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(8.363572e-02 -0.9965 0.9965 8.363572e-02 -376.6339 685.3142)",
    className: "st1",
    cx: 184.3,
    cy: 547.4,
    rx: 8.9,
    ry: 12.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(8.363572e-02 -0.9965 0.9965 8.363572e-02 -341.1533 733.6251)",
    className: "st1",
    cx: 228.3,
    cy: 552.3,
    rx: 8.9,
    ry: 12.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1069 -0.9943 0.9943 0.1069 -311.6929 763.0452)",
    className: "st1",
    cx: 268.9,
    cy: 555,
    rx: 8.9,
    ry: 11.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1069 -0.9943 0.9943 0.1069 -415.9576 623.6499)",
    className: "st1",
    cx: 139.2,
    cy: 543.4,
    rx: 8.9,
    ry: 11.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNxiTherapeuticsLogo);
export default __webpack_public_path__ + "static/media/nxi-therapeutics-logo.54b3be3274de024eaa3f9b4b206e5ef2.svg";
export { ForwardRef as ReactComponent };